import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ProductChange } from '../../shared/model/product-change';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { RouterLink, Router } from '@angular/router';
import { ChangeCategoriesComponent } from '../change-categories/change-categories.component';
import { NgClass, DatePipe, NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';


// Definition, ab wann ein Element zwei Zeilen Platz benötigt
const twoLinesInPixel = 24;

@Component({
  selector: 'myupdates-product-change-card',
  standalone: true,
  imports: [
    MatCard,
    MatIcon,
    RouterLink,
    ChangeCategoriesComponent,
    NgClass,
    DatePipe,
    NgTemplateOutlet,
    TranslatePipe
  ],
  templateUrl: './product-change-card.component.html',
  styleUrl: './product-change-card.component.scss'
})
export class ProductChangeCardComponent {
  @Input() productChange!: ProductChange;
  @Input() breakpoint: string = '';
  @Input() pcnr!: number;
  @Input() dateTranslation: string = '';
  @Input() dateTranslationMonth: string = '';
  @Input() openInNewTab: boolean = false;

  @Output() cardClick = new EventEmitter<ProductChange>();

  constructor(private router: Router) {}

  onCardClick(productChange: ProductChange, event?: Event): void {
    this.cardClick.emit(productChange);

    if (this.openInNewTab && event) {
      event.preventDefault();
      const url = this.router.createUrlTree(['/product-change/details', productChange.id]);
      // Verwende den aktuellen Pfad ohne die letzte Segment für korrekten Base-Pfad
      const baseUrl = window.location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'));
      const fullUrl = baseUrl + this.router.serializeUrl(url);
      window.open(fullUrl, '_blank', 'noopener noreferrer');
    }
  }

  isElementVerticalOverflow(elementId: string): boolean {
    const htmlElement = document.getElementById(elementId);
    const clientHeight = htmlElement?.clientHeight;
    const scrollHeight = htmlElement?.scrollHeight;

    return !!(clientHeight && scrollHeight && scrollHeight > clientHeight);
  }

  getSingleTeaserLineClamp(elementId: string): string {
    const bigHeader = this.isHeaderTwoLines(elementId) ? 1 : 0;
    const bigChangeCategory = this.isChangeCategoriesTwoLines(elementId) ? 1 : 0;

    switch (bigHeader + bigChangeCategory) {
      case 2: return 'line-clamp-3 max-h-18';

      case 0:
      case 1:
      default:
        return 'line-clamp-4 max-h-24';
    }
  }

  getMultiTeaserMaxHeight(elementId: string): string {
    const bigHeader = this.isHeaderTwoLines(elementId) ? 1 : 0;
    const bigChangeCategory = this.isChangeCategoriesTwoLines(elementId) ? 1 : 0;

    switch (bigHeader + bigChangeCategory) {
      case 2: return 'max-h-12 sm:max-h-12';
      case 0: return 'max-h-24';

      case 1:
      default:
        return 'max-h-18';
    }
  }

  isHeaderTwoLines(elementId: string): boolean {
    const element = document.getElementById(elementId);
    const clientHeight = element?.clientHeight;

    return !!clientHeight && clientHeight > twoLinesInPixel;
  }

  isChangeCategoriesTwoLines(elementId: string): boolean {
    const heightOneLine = 24;
    const element = document.getElementById('changeCat_' + elementId.split('_')[1]);
    const clientHeight = element?.clientHeight;

    return !!clientHeight && clientHeight > heightOneLine;
  }

  isTeaserLineCutOff(elementId: string, parentElementId: string): boolean {
    const element = document.getElementById(elementId);
    const parentElement = document.getElementById(parentElementId);

    if (element && parentElement) {
      const elementOffsetBottom = element.offsetTop + element.offsetHeight;
      const parentElementOffsetBottom = parentElement.offsetTop + parentElement.offsetHeight;

      if (element.offsetTop < parentElementOffsetBottom && elementOffsetBottom > parentElementOffsetBottom) {
        return true;
      }
    }

    return false;
  }
}
